import { LanguageCodes } from "../../constants/languages";

export interface ILoginPageStrings {
    UserNameLabel: string;
    PasswordLabel: string;
    AuthenticatorCodeLabel: string;
    IfMfaApplicableMessage: string;
    LoginPagetitle: string;
    LoginButton: string;
    LoginFailedMessage: string;
}

export const textEn: ILoginPageStrings = {
    UserNameLabel: "Username",
    PasswordLabel: "Password",
    LoginPagetitle: "Please login to start the Self Serve Kiosk",
    LoginButton: "Login",
    AuthenticatorCodeLabel: "Connection Code",
    IfMfaApplicableMessage: "If Multifactor Authentication is enabled",
    LoginFailedMessage: "Login failed. Check your credentials or contact your clinic administrator.",
}

export const textFr: ILoginPageStrings = {
    UserNameLabel: "Nom d'utilisateur",
    PasswordLabel: "Mot de passe",
    LoginPagetitle: "Veuillez vous connecter pour lancer le kiosque libre-service",
    LoginButton: "Connexion",
    AuthenticatorCodeLabel: "Code de connexion",
    IfMfaApplicableMessage: "Si l'authentification multifactorielle est activée",
    LoginFailedMessage: "Échec de la connexion. Vérifiez vos informations ou contactez l'administrateur de votre clinique."
}

export const textEs: ILoginPageStrings = {
    UserNameLabel: "Nombre de usuario",
    PasswordLabel: "Contraseña",
    LoginPagetitle: "Por favor ingrese para iniciar el punto de autoservicio",
    LoginButton: "Ingresar",
    AuthenticatorCodeLabel: "Código de conexión",
    IfMfaApplicableMessage: "Si la autenticación multifactor está activada",
    LoginFailedMessage: "Inicio de sesión fallido. Verifique sus credenciales o contacte al administrador de su clínica."
}

export type LoginPageLanguageService = {
    [language in LanguageCodes]: ILoginPageStrings
}

export const loginPageText: LoginPageLanguageService = {
    [LanguageCodes.English]: textEn,
    [LanguageCodes.French]: textFr,
    [LanguageCodes.Spanish]: textEs
}


// WEBPACK FOOTER //
// ./src/components/ClinicLoginPage/LoginLanguageService.ts